<template>
  <b-overlay variant="white" spinner-variant="primary" blur="0" opacity=".75" rounded="sm" :show="isLoading">
    <b-card no-body>
      <b-card-body>
        <!-- Thanh tìm kiếm -->
        <b-row class="mb-3">
          <b-col md="2">
            <b-form-input v-model="search.tieuDe" placeholder="Tiêu đề kiến nghị"></b-form-input>
          </b-col>
          <b-col md="2">
            <b-form-select v-model="search.trangThai" :options="statusOptions"></b-form-select>
          </b-col>
          <b-col md="2">
            <b-form-datepicker v-model="search.ngayGuiKn" locale="vi"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" reset-button label-reset-button="Đặt lại"
            reset-value="" placeholder="Ngày gửi" label-help="" label-no-date-selected="Chưa chọn ngày gửi"></b-form-datepicker>
          </b-col>
          <b-col md="2">
            <b-form-datepicker v-model="search.ngayPhanHoiKn" locale="vi"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" reset-button label-reset-button="Đặt lại"
            reset-value="" placeholder="Ngày phản hồi" label-help="" label-no-date-selected="Chưa chọn ngày phản hồi"></b-form-datepicker>
          </b-col>
          <b-col md="4">
            <b-button variant="primary" @click="getPhanAnhKienNghi">Tìm kiếm</b-button>
            <b-button variant="success" class="ml-2" @click="showCreateModal">Thêm mới</b-button>
          </b-col>
        </b-row>
        <!-- Bảng danh sách kiến nghị -->
        <vue-good-table :columns="columns" :rows="kienNghiList" :pagination-options="paginationOptions">
          <template slot="emptystate" style="text-align: center; font-weight: bold">Không có bản ghi nào!</template>

          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'index'">
                {{
                  (currentPage - 1) * itemsPerPage +
                    props.index +
                    1
                }}
            </span>
            <span v-else-if="props.column.field === 'status'">
              {{ props.row.trangThai === 'CHUA_GUI' ? 'Chưa gửi' : props.row.trangThai === 'DANG_XU_LY' ? 'Đang xử lý' : 'Đã phản hồi' }}
            </span>
            <span v-else-if="props.column.field === 'actions'">
              <span v-b-tooltip.hover title="Chỉnh sửa" placement="top" class="btn-icon" size="sm" style="cursor: pointer; margin-right: 6px"
                    @click="editKienNghi(props.row)" :hidden="props.row.trangThai !== 'CHUA_GUI'">
                <feather-icon icon="EditIcon" size="23" class="stroke-current" />
              </span>
              <span v-b-tooltip.hover title="Xem chi tiết" placement="top" class="btn-icon" size="sm" style="cursor: pointer; margin-right: 6px"
                    @click="viewKienNghi(props.row)">
                <feather-icon icon="InfoIcon" size="23" class="stroke-current" />
              </span>
              <span v-b-tooltip.hover title="Xóa" placement="top" class="btn-icon" size="sm" style="cursor: pointer"
                    @click="showConfirmDelete(props.row)" :hidden="props.row.trangThai !== 'CHUA_GUI'">
                <feather-icon icon="TrashIcon" size="23" class="text-danger stroke-current" />
              </span>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- Phân trang -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">Hiển thị 1 đến</span>
                <b-form-select
                  v-model="itemsPerPage"
                  :options="itemsPerPageOptions"
                  class="mx-1"
                  @input="handlePerPageChange"
                />
                <span class="text-nowrap">của {{ totalRows }} bản ghi</span>
              </div>
              <div>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="itemsPerPage"
                  class="mt-1 mb-0"
                  @input="handlePageChange"
                />
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card-body>
    </b-card>

    <!-- Popup Thêm mới -->
    <validation-observer ref="saveFormRef" #default="{ invalid }">
      <b-modal id="createKienNghiModal" 
        :title="isSave ? 'Thêm phản ánh kiến nghị' : isView ? 'Xem phản ánh kiến nghị' : 'Chỉnh sửa phản ánh kiến nghị'"
        @hidden="resetForm" hide-footer size="lg">
        <b-form @submit.prevent="saveKienNghi">
          <!-- Tiêu đề kiến nghị -->
          <b-form-group label-for="tieuDe">
            <template v-slot:label>
              Tiêu đề kiến nghị <span class="text-danger">*</span>
            </template>
            <validation-provider #default="{ errors }" name="Tiêu đề kiến nghị" rules="required">
              <b-form-input id="tieuDe" v-model="form.tieuDe" name="tieuDe" type="text"
                placeholder="Tiêu đề kiến nghị" :disabled="isView" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Ngày gửi & Ngày phản hồi -->
          <b-row>
            <b-col md="6">
              <b-form-group label-for="ngayGuiKn">
                <template v-slot:label>
                  Ngày gửi <span class="text-danger">*</span>
                </template>
                <validation-provider #default="{ errors }" name="Ngày gửi" rules="required">
                  <b-form-datepicker v-model="form.ngayGuiKn"
                      id="ngayGuiKn"
                      name="ngayGuiKn"
                      disabled
                      locale="vi"
                      date-format="D/M/YYYY"
                      label-reset-button="Đặt lại"
                      reset-button
                      reset-value=""
                      label-help=""
                      placeholder="Chọn ngày gửi"
                      label-no-date-selected="Chưa chọn ngày gửi"
                      ></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="ngayPhanHoiKn">
                <template v-slot:label>
                  Ngày phản hồi <span class="text-danger">*</span>
                </template>
                <validation-provider #default="{ errors }" name="Ngày phản hồi">
                  <b-form-datepicker v-model="form.ngayPhanHoiKn"
                      id="ngayPhanHoiKn"
                      disabled
                      locale="vi"
                      date-format="D/M/YYYY"
                      reset-button
                      reset-value=""
                      label-reset-button="Đặt lại"
                      label-help=""
                      placeholder="Chọn ngày phản hồi"
                      label-no-date-selected="Chưa chọn ngày phản hồi"
                      ></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <h5><strong>1. Kiến nghị</strong></h5>

          <!-- Tên học viên -->
          <b-form-group label-for="tenHocVien">
            <template v-slot:label>
              Tên học viên <span class="text-danger">*</span>
            </template>
            <validation-provider #default="{ errors }" name="Tên học viên">
              <b-form-input v-model="form.studentId" required hidden disabled></b-form-input>
              <b-form-input id="tenHocVien" v-model="form.tenHocVien" name="tenHocVien" type="text"
                placeholder="Nhập tên học viên" disabled />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Nội dung kiến nghị -->
          <b-form-group label-for="noiDungKienNghi">
            <template v-slot:label>
              Nội dung kiến nghị <span class="text-danger">*</span>
            </template>
            <validation-provider #default="{ errors }" name="Nội dung kiến nghị" rules="required">
              <b-form-textarea id="noiDungKienNghi" v-model="form.noiDungKienNghi" name="noiDungKienNghi" type="text"
                placeholder="Nhập nội dung kiến nghị" :disabled="isView" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- File đính kèm -->
          <b-form-group label-for="fileIdKn">
            <template v-slot:label>
              File đính kèm <span class="text-danger">*</span>
            </template>
            <validation-provider #default="{ errors }" name="File đính kèm" rules="required">
              <b-form-file id="fileIdKn" @change="setFile" v-model="form.fileIdKn" name="fileIdKn" type="file"
              :placeholder="placeholderKn" :disabled="isView" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <b-button
                        v-b-tooltip.hover.top="'Tải về'"
                        variant="success"
                        class="btn-icon"
                        style="margin-left: 6px; margin-top: 2px;"
                        size="sm"
                        @click="onDownload(form.fileIdKn)"
                        v-if="isView && form.fileIdKn"
                      >
                      Tải file
              </b-button>
          </b-form-group>

          <h5><strong>2. Phản hồi</strong></h5>

          <!-- Tên giảng viên -->
          <b-form-group label-for="teacherName">
            <template v-slot:label>
              Tên giảng viên <span class="text-danger">*</span>
            </template>
            <validation-provider #default="{ errors }" name="Tên giảng viên">
              <b-form-input v-model="form.teacherId" required hidden disabled></b-form-input>
              <b-form-input id="teacherName" v-model="form.teacherName" name="teacherName" type="text"
                placeholder="Nhập tên giảng viên" disabled />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Nội dung phản hồi -->
          <b-form-group label-for="noiDungPhanHoi">
            <template v-slot:label>
              Nội dung phản hồi <span class="text-danger">*</span>
            </template>
            <validation-provider #default="{ errors }" name="Nội dung phản hồi">
              <b-form-textarea id="noiDungPhanHoi" v-model="form.noiDungPhanHoi" name="noiDungPhanHoi" type="text"
                placeholder="Nhập nội dung phản hồi" disabled />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- File đính kèm phản hồi -->
          <b-form-group label-for="duongDanFilePhanHoi">
            <template v-slot:label>
              File đính kèm <span class="text-danger">*</span>
            </template>
            <validation-provider #default="{ errors }" name="File đính kèm">
              <b-form-file id="duongDanFilePhanHoi" v-model="form.duongDanFilePhanHoi" name="duongDanFilePhanHoi" type="file"
              :placeholder="placeholderPh" disabled />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <b-button
                        v-b-tooltip.hover.top="'Tải về'"
                        variant="success"
                        class="btn-icon"
                        style="margin-left: 6px; margin-top: 2px;"
                        size="sm"
                        @click="onDownload(form.fileIdPh)"
                        v-if="isView && form.fileIdPh"
                      >
                      Tải file
              </b-button>
          </b-form-group>

          <!-- Footer -->
          <div class="d-flex justify-content-end mt-3">
            <b-button variant="primary" type="submit" :hidden="isView" @click="onSaveAndContinue(true)">{{ isSave ? 'Lưu Nháp' : 'Cập nhật và Lưu nháp' }}</b-button>
            <b-button variant="primary" class="ml-2" :hidden="isView" @click="onSaveAndContinue(false)">Gửi</b-button>
            <b-button variant="secondary" class="ml-2" :hidden="isView" @click="xuLyDongModal">✖ Đóng</b-button>
          </div>
        </b-form>
      </b-modal>
    </validation-observer>
     <!-- Modal Xác nhận Xóa -->
     <b-modal id="confirmDeleteModal" centered hide-footer>
      <div class="text-center">
        <feather-icon icon="AlertTriangleIcon" size="48" class="text-warning mb-3 text-lg" />
        <h5 class="font-weight-bold text-lg">Bạn chắc chắn muốn xóa Kiến nghị này?</h5>
        <p class="text-muted text-md">Bạn sẽ không thể khôi phục lại dữ liệu này!</p>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <b-button variant="primary" class="mr-2 px-4 py-1 font-weight-bold" @click="confirmDelete">
          ✔ Đồng ý
        </b-button>
        <b-button variant="danger" class="px-4 py-1 font-weight-bold" @click="$bvModal.hide('confirmDeleteModal')">
          ✖ Hủy
        </b-button>
      </div>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BForm, BCard, BCardBody, BCol, BFormInput, BFormSelect, BFormDatepicker, BButton, BOverlay, BRow, BPagination, VBTooltip, BFormGroup, BFormFile, BFormTextarea, 
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapActions } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'KienNghiList',
  components: {
    BForm,
    BFormSelect,
    BPagination,
    BCol,
    BRow,
    BCard,
    BCardBody,
    BOverlay,
    BFormInput,
    BFormDatepicker,
    BButton,
    VueGoodTable,
    BFormGroup,
    BFormFile,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    const userData = JSON.parse(localStorage.getItem("qldtUser")) || {}
    return {
      userData: userData,
      kienNghiList: [], 
      formData: new FormData(),
      isLoading: false,
      search: {
        tieuDe: null,
        trangThai: null,
        ngayPhanHoiKn: null,
        ngayGuiKn: null
      },
      statusOptions: [
        { value: null, text: 'Trạng thái' },
        { value: 'CHUA_GUI', text: 'Chưa gửi' },
        { value: 'DANG_XU_LY', text: 'Đang xử lý' },
        { value: 'DA_PHAN_HOI', text: 'Đã phản hồi' },
      ],
      columns: [
        { label: 'STT', field: 'index', sortable: false, thClass: 'text-center', tdClass: 'text-center', width: '80px' },
        { label: 'Tiêu đề kiến nghị', field: 'tieuDe', sortable: true, thClass: 'text-center' },
        { label: 'Trạng thái', field: 'status', sortable: true, thClass: 'text-center', width: '200px' },
        { label: 'Ngày gửi', field: 'ngayGuiKnView', sortable: true, thClass: 'text-center', width: '200px' },
        { label: 'Ngày phản hồi', field: 'ngayPhanHoiKn', sortable: true, thClass: 'text-center', width: '200px' },
        { label: 'Thao tác', field: 'actions', sortable: false, thClass: 'text-center', tdClass: 'text-center', width: '120px' },
      ],
      itemsPerPage: 10, 
      itemsPerPageOptions: [10, 20, 30, 50, 100], 
      currentPage: 1, 
      totalRows: 0,
      paginationOptions: {
        enabled: true,
        perPage: 10, // Số bản ghi trên mỗi trang
        position: "bottom",
        dropdownAllowAll: false,
      },
      form: {
        tieuDe: '',
        ngayGuiKn: new Date(),
        ngayPhanHoiKn: null,
        studentId: userData.studentId || '',
        tenHocVien: userData.fullName || '',
        noiDungKienNghi: '',
        fileIdKn: null,
        teacherId: null,
        teacherName: null,
        noiDungPhanHoi: '',
        fileIdPh: null,
      },
      chooseId: null,
      studentId: userData.studentId || '',
      placeholderKn: 'Chọn file để tải tài liệu...',
      placeholderPh: 'Chọn file để tải tài liệu...',
      isSave: true,
      isView: false
    }
  },
  methods: {
    ...mapActions({
      getDataSources: 'hgiReflectionRecommendation/getDataSources',
      createReflectionRecommendation: 'hgiReflectionRecommendation/createReflectionRecommendation',
      createFile: 'hgiReflectionRecommendation/createFile',
      updatePhanAnhKienNghi: 'hgiReflectionRecommendation/updatePhanAnhKienNghi',
      deletePhanAnhKienNghi: 'hgiReflectionRecommendation/deletePhanAnhKienNghi',
      downloadFile: 'hgiReflectionRecommendation/downloadFile'
    }),
    formatDateToISO(date) {
      if (!date) return null
      return new Date(date).toISOString().split('.')[0]
    },
    editKienNghi(item) {
      this.isSave = false
      this.form = { ...item }
      this.form.ngayGuiKn = new Date()
      this.form.ngayPhanHoiKn = item.ngayPhanHoiKnNoFormat
      this.placeholderKn = item.fileKnName ? item.fileKnName : 'Chọn file để tải tài liệu...'
      this.placeholderPh = item.filePhName ? item.filePhName : 'Chọn file để tải tài liệu...'
      this.form.tenHocVien = item.lastName + " " + item.studentName
      this.$bvModal.show('createKienNghiModal')
    },
    viewKienNghi(item) {
      this.isSave = false
      this.isView = true
      this.form = { ...item }
      this.form.ngayGuiKn = this.formatDateToISO(item.ngayGuiKn)
      this.form.ngayPhanHoiKn = item.ngayPhanHoiKnNoFormat
      this.placeholderKn = item.fileKnName ? item.fileKnName : 'Chọn file để tải tài liệu...'
      this.placeholderPh = item.filePhName ? item.filePhName : 'Chọn file để tải tài liệu...'
      this.form.tenHocVien = item.lastName + " " + item.studentName
      this.$bvModal.show('createKienNghiModal')
    },
    showCreateModal() { this.$bvModal.show('createKienNghiModal') },
    resetForm() {
      this.formData = new FormData();
      this.isSave = true
      this.isView = false
      this.form = {
        tieuDe: '',
        ngayGuiKn: new Date(),
        ngayPhanHoiKn: null,
        studentId: this.userData.studentId || '',
        tenHocVien: this.userData.fullName || '',
        noiDungKienNghi: '',
        fileIdKn: null,
        teacherId: null,
        noiDungPhanHoi: '',
        duongDanFilePhanHoi: null,
      }
      this.placeholderKn = 'Chọn file để tải tài liệu...'
      this.placeholderPh = 'Chọn file để tải tài liệu...'
      this.$refs
        .saveFormRef
        .reset()
    },
    async handlePerPageChange(value) {
      this.itemsPerPage = value;
      this.currentPage = 1; 
      await this.getPhanAnhKienNghi(); 
    },

    async handlePageChange(value) {
      this.currentPage = value;
      await this.getPhanAnhKienNghi(); 
    },
    setFile(e) {
      this.formData = new FormData();
      const { files } = e.target
      if (files.length === 0) {
        this.showToast('File đang bị trống', 'InfoIcon', 'warning')
        this.isLoading = false
        return
      }
      files.forEach(file => this.formData.append('files', file))
    },
    async onSaveAndContinue(isDraft = false) {
      const valid = await this.$refs.saveFormRef.validate()
      if(valid) {
        let saveData = this.form;
        if(this.isSave) {
          if([...this.formData.entries()].length === 0) {
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Vui lòng chọn file trước khi lưu!',
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            }) 
          this.isLoading = false
            this.$bvModal.show('createKienNghiModal')
            return;
          }
          try {
              const fileRepon = await this.createFile(this.formData)
              if (fileRepon.isSuccessful) {
                saveData.fileIdKn = fileRepon.data
                saveData.ngayGuiKn = new Date(saveData.ngayGuiKn)
                isDraft ? saveData.trangThai = "CHUA_GUI" : saveData.trangThai = "DANG_XU_LY"
                const reponse = await this.createReflectionRecommendation(saveData)
                if (reponse.isSuccessful) {
                  this.isLoading = false
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                    title: reponse.message,
                    icon: 'CheckIcon',
                    variant: 'success',
                    },
                  })
                  isDraft ? this.$bvModal.show('createKienNghiModal') : this.$bvModal.hide('createKienNghiModal')
                  isDraft ? this.isLoading = false : this.isLoading = true   
                  this.resetForm()
                  this.getPhanAnhKienNghi() 
                }
              }
          } catch (error) {
           ( error.code && error.code === 5) ? (
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
           ) : (
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Tiêu đề kiến nghị đã tồn tại!',
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
           )
          } 
        } else {
          this.isLoading = true
            try {
              if([...this.formData.entries()].length !== 0) {
                const fileRepon = await this.createFile(this.formData)
                if (fileRepon.isSuccessful) {
                  saveData.fileIdKn = fileRepon.data
                  isDraft ? saveData.trangThai = "CHUA_GUI" : saveData.trangThai = "DANG_XU_LY"
                  saveData.ngayGuiKn = new Date(saveData.ngayGuiKn)
                  this.capNhatPhanAnhKienNghi(saveData)
                }
                } else {
                  isDraft ? saveData.trangThai = "CHUA_GUI" : saveData.trangThai = "DANG_XU_LY"
                  saveData.ngayGuiKn = new Date(saveData.ngayGuiKn)
                  this.capNhatPhanAnhKienNghi(saveData)
                }
            } catch (error) {
                (error.code && error.code === 5) ? (
                this.$bvModal.show('createKienNghiModal'),
                this.isLoading = false,
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              ) : (
                this.isLoading = false,
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Chỉnh sửa kiến nghị thất bại!',
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              )
            }
          }   
      } 
    },
    async getPhanAnhKienNghi() {
      this.isLoading = true
      this.search.ngayGuiKn = this.search.ngayGuiKn ? this.search.ngayGuiKn : null 
      this.search.ngayPhanHoiKn = this.search.ngayPhanHoiKn ? this.search.ngayPhanHoiKn : null 
      try {
        const respon = await this.getDataSources({...this.search,  studentId: this.studentId, currentPage: this.currentPage, itemsPerPage: this.itemsPerPage})
        this.$set(this, 'kienNghiList', respon.data.records)
        this.$set(this, 'totalRows', respon.data.total)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Lỗi khi lấy danh sách phản ánh kiến nghị',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async xoaPhanAnhKienNghi() {
      this.isLoading = true
      try {
        const respon = await this.deletePhanAnhKienNghi( { id: this.chooseId  })
        if(respon.isSuccessful) {
            this.isLoading = false
            this.$swal({
            icon: 'success',
            title: 'Đã xóa thành công!',
            showConfirmButton: false,
            timer: 1500
          });
          await this.getPhanAnhKienNghi()
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Lỗi khi xóa phản ánh kiến nghị',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      }
    },
    showConfirmDelete(row) {
      this.chooseId = row.id;
      this.$bvModal.show('confirmDeleteModal');
    },
    confirmDelete() {
      this.$bvModal.hide('confirmDeleteModal');
      this.isLoading = true
      try {
         this.xoaPhanAnhKienNghi()
      } catch (error) {
      }
    },
    xuLyDongModal() {
      this.isSave = true
      this.isView = false
      this.resetForm()
      this.$bvModal.hide('createKienNghiModal')
    },
    async capNhatPhanAnhKienNghi(data) {
      const reponse = await this.updatePhanAnhKienNghi(data)
          if (reponse.isSuccessful) {
            this.isLoading = false
            this.$toast({
              component: ToastificationContent,
              props: {
              title: reponse.message,
              icon: 'CheckIcon',
              variant: 'success',
              },
          })
          this.resetForm()
          this.getPhanAnhKienNghi()
          this.$bvModal.hide('createKienNghiModal')      
        }
    },
    async onDownload(id) {
        try {
            const url = await this.downloadFile({ id: id })
            if (url) {
            window.open(url, '_blank')
            }
        } catch (e) {
            this.$toast({
            component: ToastificationContent,
            props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
            },
            })
        } finally {
            this.isLoading = false
        }
        },
  },
  async mounted() {
    if (!Array.isArray(this.kienNghiList) || !this.kienNghiList.length) {
      await this.getPhanAnhKienNghi()
    }
  },
}
</script>

  <style lang="scss">
@import "@core/scss/vue/libs/vue-good-table";
  ::v-deep(.vue-good-table .thead th) {
  text-align: center !important;
  }

  .text-lg {
    font-size: 25px; 
  }

  .text-md {
    font-size: 1.1rem; 
  }
</style>
